import { render, staticRenderFns } from "./EndorsementContractPolicyData.vue?vue&type=template&id=6d56a68e"
import script from "./EndorsementContractPolicyData.vue?vue&type=script&lang=js"
export * from "./EndorsementContractPolicyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports